






















import {
  Vue,
  Component
} from "@/shared/vuepack";
import { Location } from "vue-router";
import * as routes from "@/employee/route-names";
import * as sharedRoutes from "@/shared/route-names";
import { useUserStore } from "@/shared/store/user";

@Component
export default class HealthcareExpenseNavigationV2 extends Vue {
  userStore = useUserStore();

  routes = routes;
  sharedRoutes = sharedRoutes;

  mounted (): void {
    this.userStore.loadPartnerSettings();
  }

  get activeTab () {
    return this.$route.name;
  }

  get activeTabIndex () {
    return Array.from(this.navItems.keys()).findIndex(i => i.name === this.activeTab);
  }

  get navItems () {
    const items = new Map<Location, string>();

    items.set({ name: routes.EligibleExpenses }, "My Eligible Expenses");
    items.set({ name: routes.FindExpenses }, "Find More Eligible Expenses");
    if (!this.userStore.partnerDisableTalon) {
      items.set({ name: routes.ViewClaims }, "View and link healthcare claims");
    }

    return items;
  }

}
